import ProspectingStrategy from "../component/Prospecting_strategy";

/**
 * 営業ダッシュボード本体。
 * 以前の営業戦略ダッシュボードにあったKPI・複数グラフ・要フォロー一覧・
 * メンバー別対応状況を、現在の共通テーマで表示する。
 */
export default function Dashboard() {
  return <ProspectingStrategy />;
}
